<i18n>
{
  "fr": {
    "files": "Pièces jointes",
    "photos": "Photos",
    "schema": "Schémas",
    "technicalFiles": "Documents techniques",
    "report": "Comptes rendus",
    "other": "Autres",
    "download": "Télécharger",
    "fileName": "Nom du fichier",
    "fileSize": "Taille"
  }
}
</i18n>

<template>
  <div class="panel panel-info text-left">
    <div class="panel-heading">{{ $t('files') }}</div>
    <div class="panel-body">
      <div class="xs-12">
        <h4>{{ $t('photos') }}</h4>
        <hr>
        <div class="account-error-div">
          <table class="table admin-list">
            <thead v-if="photos">
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in photos" :key="file.id" class="request_row">
                <td>
                  <v-icon name="file"/>
                  {{ file.originalFileName }}
                </td>
                <td>{{ file.size }}</td>
                <td>
                  <a v-if="controlId !== 'undefined'" :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4>{{ $t('schema') }}</h4>
        <hr>
        <div class="account-error-div">
          <table class="table admin-list">
            <thead v-if="schemas">
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in schemas" :key="file.id" class="request_row">
                <td>
                  <v-icon name="file"/>
                  {{ file.originalFileName }}
                </td>
                <td>{{ file.size }}</td>
                <td>
                  <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4>{{ $t('technicalFiles') }}</h4>
        <hr>
        <div class="account-error-div">
          <table class="table admin-list">
            <thead v-if="technicalFiles">
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in technicalFiles" :key="file.id" class="request_row">
                <td>
                  <v-icon name="file"/>
                  {{ file.originalFileName }}
                </td>
                <td>{{ file.size }}</td>
                <td>
                  <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4>{{ $t('report') }}</h4>
        <hr>
        <div class="account-error-div">
          <table class="table admin-list">
            <thead v-if="reports">
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in reports" :key="file.id" class="request_row">
                <td>
                  <v-icon name="file"/>
                  {{ file.originalFileName }}
                </td>
                <td>{{ file.size }}</td>
                <td>
                  <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4>{{ $t('other') }}</h4>
        <hr>
        <div class="account-error-div">
          <table class="table admin-list">
            <thead v-if="others">
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in others" :key="file.id" class="request_row">
                <td>
                  <v-icon name="file"/>
                  {{ file.originalFileName }}
                </td>
                <td>{{ file.size }}</td>
                <td>
                  <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  Name: 'FileDetail',
  props: {
    photos: { required: true },
    schemas: { required: true },
    technicalFiles: { required: true },
    reports: { required: true },
    others: { required: true },
  },

  computed: {
    ...mapState({ controlId: state => state.route.params.controlId }),
  },
  methods: {
    getLink(fileId) {
      return this.$store.getters.getLinkFileControl({ controlId: this.controlId, fileId: fileId });
    },
  },
};
</script>




